import service from "@/store/services/workshop/spare_part_request-service";

const state = {
  list: {},
  spare_part_request: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, spare_part_request) => {
    state.spare_part_request = spare_part_request;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((spare_part_request) => {
      commit("SET_RESOURCE", spare_part_request);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((spare_part_request) => {
      commit("SET_RESOURCE", spare_part_request);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((spare_part_request) => {
      commit("SET_RESOURCE", spare_part_request);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },

  last_no({ commit, dispatch }, params) {
    return service.last_no(params).then((spare_part_request) => {
      commit("SET_RESOURCE", spare_part_request);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  spare_part_request: (state) => state.spare_part_request,
  page: (state) => state.meta.page,
};

const spare_part_request = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default spare_part_request;
